/**
 * Targeted embeds (area placements + activating inline campaigns) unlock on Pro.
 */
const TARGETED_EMBEDS_GATED_PLANS = [
  "free",
  "2026_personal",
  "2026_prime",
  "2024_pages",
  "2024_core",
  "2024_funnels",
  "2024_pro",
  "2025_pro",
];

export function isTargetedEmbedsGated(planType, websitePremium) {
  return (
    TARGETED_EMBEDS_GATED_PLANS.includes(String(planType || "")) ||
    websitePremium === false ||
    websitePremium === "false"
  );
}

export function targetedEmbedsUpgradePlan(_planType) {
  return "pro";
}

export default isTargetedEmbedsGated;
